import { createFileRoute } from "@tanstack/react-router";
import { WorkflowBuilderPage } from "@/features/workflowbuilder/WorkflowBuilderPage";

export const Route = createFileRoute("/_app/automations/$workflow/")({ component: Page });

function Page() {
  const { workflow } = Route.useParams();
  return <WorkflowBuilderPage id={workflow} />;
}
